export default "__VITE_ASSET__1zlJxLiA__"